<template ref="tab1Grid">
  <div>
    <div class="mrB20" />
    <sui-grid
      ref="mainGrid"
      :dataset="'datasetInfo'"
      :columns="defaultGridData0.columns"
      :enabletooltips="true"
      :initialPagesize="5"
      :showDisplayCountControl="false"
    />
  </div>
</template>
<script>
export default {
  name: "PGE_CMT_00001_T01", // eslint-disable-line vue/name-property-casing
  props: {
    pageId: {
      type: String,
      default: ""
    },
    selectedPageId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      localdata: [],
      defaultGridData0: {
        columns: [
          {
            text: this.$t("MSG_TXT_TRM_NM"),
            datafield: "termsName",
          },
          {
            text: this.$t("MSG_TXT_TRM_PHSC_NM"),
            datafield: "termsId",
            width: 200,
          },
          {
            text: this.$t("MSG_TXT_TRM_CNTN"),
            datafield: "termsContent",
          },
          {
            text: this.$t("MSG_TXT_DOMAIN_NAME"),
            datafield: "domainName",
            width: 200,
          },
          {
            text: this.$t("MSG_TXT_DT_TYP_NM"),
            datafield: "domainDataTypeName",
            width: 100,
          },
          {
            text: this.$t("MSG_TXT_LEN"),
            datafield: "domainLength",
            width: 80,
            cellsalign: 'right',
          },
          {
            text: this.$t("MSG_TXT_DECM_LGHT"),
            datafield: "domainDataDecimalLength",
            width: 100,
            cellsalign: 'right',
          }
        ]
      }
    };
  },
  datasets: [
    {
      id: "datasetInfo",
      type: "local",
      data: "localdata",
      datafields: [
        { name: "termsName", type: "string", map: "termsName" },
        { name: "termsId", type: "string", map: "termsId" },
        { name: "termsContent", type: "string", map: "termsContent" },
        { name: "domainName", type: "string", map: "domainName" },
        {
          name: "domainDataTypeName",
          type: "string",
          map: "domainDataTypeName"
        },
        { name: "domainLength", type: "string", map: "domainLength" },
        {
          name: "domainDataDecimalLength",
          type: "string",
          map: "domainDataDecimalLength"
        }
      ]
    }
  ],
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    getDataByDomainId(domainId) {
      if (domainId === null) {
        this.datasetInfo.setRawData([]);
      } else {
        http
          .request("PGE_CMT_00001", "DTS_CMT_00007", {
            path: {
              "domain-id": domainId
            }
          })
          .then(res => {
            this.datasetInfo.setRawData(res.data);
          })
          .catch(error => {
            console.log(error);
          });
      }
    }
  }
};
</script>
<style scoped>
.line-textarea {
  padding: 0px 8px;
  line-height: 28px;
}
</style>
